import React, { useCallback, useState } from 'react'

import { useAuthInfo, useLogoutFunction } from '@sweetauth/core'

import Button from '@/components/common/Button'

export const AuthError: React.FC = () => {
  const authInfo = useAuthInfo()
  const { refreshAuthInfo } = authInfo
  const sessionError =
    authInfo.isLoggedIn === false ? authInfo.sessionError : undefined
  const logout = useLogoutFunction()
  const [pendingAction, setPendingAction] = useState<'retry' | 'logout' | null>(
    null,
  )

  const handleRetry = useCallback(async () => {
    setPendingAction('retry')
    try {
      await refreshAuthInfo()
    } finally {
      setPendingAction(null)
    }
  }, [refreshAuthInfo])

  const handleSignOut = useCallback(async () => {
    setPendingAction('logout')
    try {
      await logout(true)
    } finally {
      setPendingAction(null)
    }
  }, [logout])

  return (
    <main className="flex h-dvh items-center justify-center overflow-y-auto bg-primary-50 px-6 dark:bg-default-dark">
      <div className="flex max-w-md flex-col gap-5 text-center">
        <div role="alert">
          <h1 className="text-xl font-semibold">
            Unable to verify your session
          </h1>
          <p className="mt-3">
            {sessionError ??
              "We couldn't finish signing you in. Try again, or contact your administrator if this continues."}
          </p>
        </div>
        <div className="flex justify-center gap-3">
          <Button
            type="button"
            variant="primary"
            disabled={pendingAction !== null}
            isLoading={pendingAction === 'retry'}
            onClick={handleRetry}
          >
            Try again
          </Button>
          <Button
            type="button"
            variant="outline"
            disabled={pendingAction !== null}
            isLoading={pendingAction === 'logout'}
            onClick={handleSignOut}
          >
            Sign out
          </Button>
        </div>
      </div>
    </main>
  )
}
